module.exports = __webpack_public_path__ + "static/img/萌小乙.dbd59646.png";